export default __webpack_public_path__ + "static/media/showroom45.b511ef93.webp";